
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/component-api/Sparkline",
      function () {
        return require("private-next-pages/component-api/Sparkline.mdx");
      }
    ]);
  